import PropTypes from 'prop-types';

const captionProps = {
  id: PropTypes.number.isRequired,
  caption: PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  campaign: PropTypes.shape({
    name: PropTypes.string.isRequired,
    sentDate: PropTypes.string.isRequired,
  }),
  timestamp: PropTypes.string,
  isSponsored: PropTypes.bool.isRequired,
  bookmarked: PropTypes.bool,
  showBookmarkHint: PropTypes.bool,
};

const defaultCaptionProps = {
  bookmarked: false,
  showBookmarkHint: false,
  campaign: null,
  timestamp: null,
};

export {
  captionProps,
  defaultCaptionProps,
};
